import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

const WithTranslations = ({ i18n, translations, children }) => {
  useEffect(() => {
    if (i18n.languages && translations) {
      i18n.languages.forEach(language => {
        if (translations[language] && !i18n.hasResourceBundle(language, 'app')) {
          i18n.addResources(language, 'app', translations[language]);
        }
      });
    }
  }, [translations, i18n]);

  return <>{children}</>;
};

WithTranslations.propTypes = {
  i18n: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  translations: PropTypes.object.isRequired,
};

export default compose(withTranslation('shared'))(WithTranslations);
